import React, {useState} from "react";
import {QRCodeSVG} from "qrcode.react";
import {useSessionListenUrl} from "./hooks/useSessionListenUrl";
import {QrCode} from "lucide-react";

export function RoomQRCode() {
    const [open, setOpen] = useState(false);
    const url = useSessionListenUrl();

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                className="flex items-center px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
            >
                <QrCode className="h-5 w-5 mr-2" />
                QR Code
            </button>
            {open && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white w-full h-full flex items-center justify-center">
                        <QRCodeSVG value={url} style={{ height: '90%', width: '90%' }} />
                        <button
                            onClick={() => setOpen(false)}
                            className="absolute top-4 right-4 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}
